export default __webpack_public_path__ + "static/media/logoNeitor.64516010.png";